<template>
  <div>
    <Title :pages="[{ icon: 'arrow-right', page: page_title.toUpperCase() }]"></Title>
    <v-container fluid>
      <!-- v-if="create_access" -->
      <v-btn flat class="mb-3 btn-second" @click="updateDialog(true)">Crear {{ modal_title }}</v-btn>
      <v-btn outlined class="ml-3 mb-3 btn-third" @click="updateDialogImportExcel(true)">Importar {{ modal_title }}</v-btn>

      <Modal
        v-if="create_access"
        :button_name="'Crear ' + modal_title"
        :modal_title="modal_title"
        :page_title="page_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :editItem="mainItem"
        :isClient="isClient()"
      />

      <ModalImportExcel
        v-if="create_access"
        :service="service"
        button_name="Importar Excel"
        modal_title="Importar ASN desde Excel"
        page_title="ASN"
        formBtn="Importar"
        :dialog="dialog_import_excel"
        @updateDialog="updateDialogImportExcel"
        @loadList="loadList(service)"
      />

      <!-- 
        desde
        hasta
        tipo de documento
        estado
        cliente 
        referencia externa 
        -->

      <v-card class="mb-4">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3">
                  <v-text-field v-model="filters.estimated_arrival_date_from" density="comfortable" type="date" name="estimated_arrival_date_from" label="Desde" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.estimated_arrival_date_to" density="comfortable" type="date" name="estimated_arrival_date_to" label="hasta" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.almacen"
                    density="comfortable"
                    name="almacen"
                    item-title="name"
                    item-value="id"
                    :items="almacenes"
                    label="Almacen"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.document_type"
                    name="document_type"
                    density="comfortable"
                    item-title="name"
                    item-value="id"
                    :items="documents_types"
                    label="Tipo de Documento"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3">
                  <v-text-field v-model="filters.id" density="comfortable" label="Numero" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.external_reference" density="comfortable" label="Referencia Externa" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.status"
                    density="comfortable"
                    name="status"
                    item-title="name"
                    item-value="id"
                    :items="status"
                    label="Estado de ASN"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.sub_status"
                    density="comfortable"
                    name="sub_status"
                    item-title="name"
                    item-value="id"
                    :items="sub_status"
                    label="Subestado de ASN"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-3" v-if="!isClient()">
                  <v-combobox
                    v-model="filters.client"
                    density="comfortable"
                    name="cliente"
                    item-title="name"
                    item-value="id"
                    :items="clients"
                    label="Cliente"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>

                <div :class="isClient() ? 'col-md-12 pt-2' : 'col-md-9 pt-0 pb-3'" style="display: flex; justify-content: end; gap: 10px">
                  <v-btn color="blue-grey" class="mr-3" small dark :loading="dialog_export" @click="exportFile()">
                    Exportar
                    <font-awesome-icon class="ml-2" icon="download" />
                  </v-btn>
                  <v-btn color="info" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card>
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <!-- v-if="list_access" -->

        <v-data-table v-if="list_access" :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.id }}</td>
              <td>{{ item.estimated_arrival_date }}</td>
              <td class="table-text-secondary">{{ item.almacen_code }}</td>
              <td v-if="!isClient()">{{ item.client_user_name }}</td>
              <td>
                {{ item.document_type_name }}<br />
                <span v-if="item.external_reference != null" class="table-text-secondary">Ref: {{ item.external_reference }}</span>
              </td>
              <td>{{ item.reception_type_name != null ? item.reception_type_name : "-" }}</td>
              <td>{{ item.observaciones }}</td>

              <td>
                <div class="status-badge font-weight-medium" :class="'status-' + item.status">
                  {{ service.getStatusName(item.status) }}
                  <p class="text-caption text-grey-600 mb-0" v-if="item.sub_status">
                    {{ service.getSubStatusName(item.sub_status) }}
                  </p>
                </div>
              </td>

              <td class="text-center" style="width: 180px">
                <v-tooltip bottom v-if="!isClient()">
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="update_access" v-bind="props" small color="green" class="mr-2" v-on:click="goToRecepcion(item)" size="small"> mdi-arrow-right-box</v-icon>
                  </template>
                  <span v-if="item.status != service.STATE_CERRADO">Recibir</span>
                  <span v-else>Detalle de recepción</span>
                </v-tooltip>

                


                <v-tooltip bottom v-if="item.status === service.STATE_PENDIENTE">
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="update_access" v-bind="props" small color="blue" class="mr-2" v-on:click="editItem(item)" size="small"> mdi-pencil</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="viewItem(item)" size="small"> mdi-eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom v-if="item.has_remitos">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue-grey" class="mr-2" v-on:click="viewRemitos(item)" size="small"> mdi-file-document-multiple </v-icon>
                  </template>
                  <span>Ver remitos/facturas</span>
                </v-tooltip>

                <v-menu location="bottom" offset-y>
                  <template #activator="{ props }">
                    <v-icon v-bind="props" color="blue-grey" class="mr-2" size="small"> mdi-printer </v-icon>
                  </template>

                  <v-list>
                    <v-list-item @click="printAsn(item)" link v-if="item.status === service.STATE_CERRADO">
                      <v-list-item-title>Descargar Remito</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="printAsn(item, true)" link v-if="item.status === service.STATE_CERRADO">
                      <v-list-item-title>Ver Remito</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="openPrintWitness(item)" link v-if="item.status !== service.STATE_PENDIENTE && !isClient()">
                      <v-list-item-title>Imprimir Etiqueta Testigo</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="openPrintLabel(item)" link>
                      <v-list-item-title>Imprimir Etiqueta</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-menu location="bottom" offset-y>
                  <template #activator="{ props }">
                    <v-icon v-bind="props" color="blue-grey" class="mr-2" size="small"> mdi-dots-vertical </v-icon>
                  </template>

                  <v-list>                      
                    <v-list-item @click="openSummary(item)" link v-if="item.status != service.STATE_PENDIENTE">
                      <template v-slot:prepend>
                        <v-icon color="blue-grey" size="small">mdi-file-document-check</v-icon>
                      </template>
                      <v-list-item-title>Resumen de recepción</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="viewPhotos(item)" link v-if="item.has_photos">
                      <template v-slot:activator="{ props }">
                        <v-icon v-if="item.has_photos" v-bind="props" small color="blue" class="mr-2" v-on:click="viewPhotos(item)" size="small">mdi-image-multiple </v-icon>
                      </template>
                      <v-list-item-title>Ver imágenes</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="editObservaciones(item)" link v-if="update_access && service.canEditObservaciones(item.status)">
                      <template v-slot:prepend>
                        <v-icon color="blue-grey" size="small">mdi-note-edit</v-icon>
                      </template>
                      <v-list-item-title>Editar observaciones</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="viewHistorial(item)" link v-if="update_access">
                      <template v-slot:prepend>
                        <v-icon color="blue-grey" size="small">mdi-timer</v-icon>
                      </template>
                      <v-list-item-title>Ver historial</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="viewDifference(item)" link v-if="item.sub_status == service.SUB_STATE_CON_DIFERENCIA" >
                        <template v-slot:prepend>
                        <v-icon color="green" size="small">mdi-check</v-icon>
                      </template>
                      <v-list-item-title>Validar diferencias</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="deleteItem(item)" link v-if="item.status === service.STATE_PENDIENTE && delete_access">
                      <template v-slot:prepend>
                        <v-icon color="red" size="small">mdi-delete</v-icon>
                      </template>
                      <v-list-item-title>Eliminar</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <ModalSummary :asn="asn" :dialog="dialog_summary" @updateDialog="dialog_summary = false" />
      <ModalViewImages :dialog="dialog_photos" :photos="selected_photos" @updateDialog="dialog_photos = false" />
      <ModalPrint :show="dialog_print_label" :asn="selected_asn" @close="dialog_print_label = false" />
      <ModalSelectLpnForWitness 
        :dialog="dialog_select_lpns_witness" 
        :asn="selected_asn" 
        @close="dialog_select_lpns_witness = false"
        @lpnsSelected="openPrintWitnessWithSelectedLpns"
      />
      <ModalPrintWitness 
        :show="dialog_print_witness" 
        :asn="selected_asn" 
        :selectedLpns="selected_lpns_for_witness"
        @close="closePrintWitness" 
      />
      <DialogPrintWithImages v-model="dialog_print_with_images" :imageCount="selected_asn_image_count" :loading="loading" @confirm="handlePrintWithImages" />
      <ModalHistorial title="Historial" :dialog_view="dialog_view_historial" :asn_id="asn_id"  @closeDialog="closeDialogHistorial" />
      <ModalRemitos title="Remitos/Facturas" :dialog_view="dialog_view_remitos" :remitos="selected_remitos" @closeDialog="closeDialogRemitos" />
      <ModalObservaciones :dialog="dialog_observaciones" :asn="selected_asn" @updateDialog="dialog_observaciones = false" @loadList="loadList(service)" />
      <ModalDifference :dialog="dialog_view_difference" :asn="asn"  @updateDialog="closeDialogDifference" @loadList="loadList" />

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />
    </v-container>
  </div>
</template>

<script>
import { asnService } from "@/libs/ws/asnService";
import { clientService } from "@/libs/ws/clientService";
import { documentsTypeService } from "@/libs/ws/documentsTypeService";
import { almacenService } from "@/libs/ws/almacenService";
import DialogDelete from "@/components/DialogDelete.vue";
import GenericMixin from "@/mixins/GenericMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Modal from "./Modal.vue";
import Constant from "@/constants/sections";
import ModalSummary from "./ModalSummary.vue";
import ModalHistorial from "./ModalHistorial.vue";
import ModalRemitos from "./ModalRemitos.vue";
import ModalViewImages from "@/components/ModalViewImages.vue";
import ModalPrint from "./ModalPrint.vue";
import ModalPrintWitness from "./ModalPrintWitness.vue";
import ModalSelectLpnForWitness from "./ModalSelectLpnForWitness.vue";
import DialogPrintWithImages from "./DialogPrintWithImages.vue";
import ModalImportExcel from "./ModalImportExcel.vue";
import { mapState, mapMutations } from "vuex";
import { generalService } from "@/libs/ws/generalService";
import ModalDifference from "./ModalDifference.vue";
import ModalObservaciones from "./ModalObservaciones.vue";

export default {
  components: { 
    Modal, 
    ModalSummary, 
    DialogDelete, 
    ModalViewImages, 
    ModalPrint, 
    ModalPrintWitness, 
    ModalSelectLpnForWitness,
    DialogPrintWithImages, 
    ModalHistorial,
    ModalRemitos,
    ModalDifference,
    ModalImportExcel,
    ModalObservaciones
  },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      service: asnService,
      page_title: "ASN",
      modal_title: "ASN",
      asn: null,
      dialog_summary: false,
      dialog_print_label: false,
      selected_asn: null,
      documents_types: [],
      clients: [],
      almacenes: [],
      status: [],
      sub_status: [],
      headers: [
        {
          title: "Numero",
          align: "left",
          sortable: true,
          key: "id",
        },
        {
          title: "Fecha estimada",
          align: "left",
          sortable: true,
          key: "estimated_arrival_date",
        },
        {
          title: "Almacen",
          align: "left",
          sortable: true,
          key: "almacen_code",
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          key: "client_user_name",
          visible_for_client: false,
        },
        {
          title: "Documento",
          align: "left",
          sortable: true,
          key: "external_reference",
        },
        {
          title: "Tipo de Recepcion",
          align: "left",
          sortable: true,
          key: "reception_type_name",
        },
        {
          title: "Observaciones",
          align: "left",
          sortable: true,
          key: "observaciones",
        },
        {
          title: "Estado",
          align: "left",
          sortable: true,
          key: "status_name",
        },

        { title: "Accion", align: "center", sortable: false, key: "" },
      ],
      filters: {
        estimated_arrival_date_from: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        estimated_arrival_date_to: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        estimated_arrival_date: "",
        document_type: null,
        status: null,
        sub_status: null,
        client: null,
        almacen: null,
        id: "",
        external_reference: "",
      },
      selected_photos: [],
      dialog_photos: false,
      dialog_print_witness: false,
      dialog_select_lpns_witness: false,
      selected_lpns_for_witness: [],
      dialog_print_with_images: false,
      selected_asn_for_print: null,
      selected_asn_image_count: 0,
      print_action_open: false,
      dialog_view_historial: false,
      dialog_view_remitos: false,
      selected_remitos: [],
      dialog_view_difference: false,
      dialog_import_excel: false,
      dialog_observaciones: false
    };
  },
  computed: {
    // Mapear el estado de los filtros de ASN = this.$store.state.asn_filters
    ...mapState(["asn_filters"]),
  },
  watch: {
    // Guardar automáticamente los filtros cuando cambien
    filters: {
      handler(newFilters) {
        this.setAsnFilters(newFilters);
      },
      deep: true,
    },
  },
  mounted() {
    // Cargar filtros desde el store si existen
    if (this.asn_filters && Object.keys(this.asn_filters).length > 0) {
      this.filters = { ...this.filters, ...this.asn_filters };
    } else {
      // Si no hay filtros guardados, usar los valores por defecto
      this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));
    }

    //recorro los headers y saco el cliente si el usuario es el cliente
    this.headers = this.headers.filter((header) => {
      if (header.visible_for_client || header.visible_for_client == undefined) {
        return true;
      }
      return !this.isClient();
    });

    this.loadList(this.service);
    this.loadAlmacenes();
    this.loadClientes();
    this.loadDocumentTypes();
    this.loadStatus();
    this.loadSubStatus();
  },
  methods: {
    // Mapear el estado de los filtros de ASN = this.$store.commit
    ...mapMutations(["setAsnFilters"]),
    // El listado (V2) devuelve objetos planos sin las relaciones ni las urls de las fotos,
    // asi que cuando se necesita el ASN completo se pide on-demand.
    fetchAsn(id) {
      this.loading = true;
      return asnService
        .get({ id: id })
        .then((response) => {
          if (!response.status) {
            this.$toast.error(response.msg, "Error");
            return null;
          }
          return response.result;
        })
        .catch((e) => {
          console.log("service.get error");
          console.log(e);
          return null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    printAsn(item, open = false) {
      // Verificar si el ASN tiene imágenes
      if (!item.has_photos) {
        // No hay imágenes, imprimir directamente sin imágenes
        this.executePrintAsn(item.id, open, false);
        return;
      }

      this.fetchAsn(item.id).then((asn) => {
        if (asn == null) return;

        if (asn.photos_urls && asn.photos_urls.length > 0) {
          // Guardar el item y la acción para ejecutar después de la confirmación
          this.selected_asn_for_print = asn;
          this.selected_asn_image_count = asn.photos_urls.length;
          this.print_action_open = open;
          this.dialog_print_with_images = true;
        } else {
          this.executePrintAsn(item.id, open, false);
        }
      });
    },

    viewDifference(item) {
      this.asn = item;
      this.dialog_view_difference = true;
    },
    closeDialogDifference() {
      this.asn = null;
      this.dialog_view_difference = false;
    },
    editObservaciones(item) {
      this.fetchAsn(item.id).then((asn) => {
        if (asn == null) return;
        this.selected_asn = asn;
        this.dialog_observaciones = true;
      });
    },
    viewHistorial(item) {
      this.asn_id = item.id;
      this.dialog_view_historial = true;
    },
    closeDialogHistorial() {
      this.asn_id = null;
      this.dialog_view_historial = false;
    },
    viewRemitos(item) {
      this.selected_remitos = item.remitos != null ? item.remitos : [];
      this.dialog_view_remitos = true;
    },
    closeDialogRemitos() {
      this.selected_remitos = [];
      this.dialog_view_remitos = false;
    },
    updateDialogImportExcel(value) {
      this.dialog_import_excel = value;
    },
    handlePrintWithImages(includeImages) {
      // Cerrar el diálogo
      this.dialog_print_with_images = false;

      // Ejecutar la impresión con o sin imágenes
      if (this.selected_asn_for_print) {
        this.executePrintAsn(this.selected_asn_for_print.id, this.print_action_open, includeImages);

        // Limpiar variables temporales
        this.selected_asn_for_print = null;
        this.selected_asn_image_count = 0;
        this.print_action_open = false;
      }
    },
    executePrintAsn(asnId, open = false, includeImages = false) {
      this.loading = true;

      const params = includeImages ? { include_images: true } : {};

      asnService
        .print_asn(asnId, params)
        .then((response) => {
          const fileName = includeImages ? `ASN-${asnId}-con-imagenes.pdf` : `ASN-${asnId}.pdf`;

          if (!generalService.downloadPdf(response, fileName, open)) {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          this.$toast.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    viewPhotos(item) {
      this.fetchAsn(item.id).then((asn) => {
        if (asn == null) return;
        this.selected_photos = asn.photos_urls || [];
        this.dialog_photos = true;
      });
    },
    openSummary(item) {
      this.asn = item;
      this.dialog_summary = true;
    },
    openPrintLabel(item) {
      this.selected_asn = item;
      this.dialog_print_label = true;
    },
    openPrintWitness(item) {
      this.selected_asn = item;
      this.selected_lpns_for_witness = [];
      this.dialog_select_lpns_witness = true;
    },
    openPrintWitnessWithSelectedLpns(selectedLpns) {
      this.selected_lpns_for_witness = selectedLpns;
      this.dialog_select_lpns_witness = false;
      this.dialog_print_witness = true;
    },
    closePrintWitness() {
      this.dialog_print_witness = false;
      this.selected_lpns_for_witness = [];
    },
    goToRecepcion(item) {
      this.$router.push("/" + Constant.SECTION_ASN + "/recepcion/" + item.id);
    },
    //El listado es RAW, se necesita el objeto completo (asn_details) para el modal
    loadItemAndOpenModal(item) {
      this.loading = true;
      asnService
        .get({ id: item.id })
        .then((response) => {
          this.mainItem = response.result;
          this.dialog = true;
        })
        .catch((e) => {
          console.log("service.get error");
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    viewItem(item) {
      this.viewdIndex = this.list.indexOf(item);
      this.loadItemAndOpenModal(item);
    },
    editItem(item) {
      this.editedIndex = this.list.indexOf(item);
      this.loadItemAndOpenModal(item);
    },
    getFilterParams() {
      return this.filters;
    },
    filter() {
      // Guardar filtros en el store antes de hacer la búsqueda
      this.setAsnFilters(this.filters);
      this.loadList(this.service);
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadClientes() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadDocumentTypes() {
      documentsTypeService
        .filter()
        .then((response) => {
          this.documents_types = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadStatus() {
      asnService
        .list_status()
        .then((response) => {
          this.status = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadSubStatus() {
      asnService
        .list_sub_status()
        .then((response) => {
          this.sub_status = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    exportFile() {
      var param = { ...this.getFilterParams() }; // Copia de this.filters
      param["export"] = true;
      this.exportExcel(this.service.section + "/export", param, "ASNs.xlsx");
    },
  },
};
</script>
